import { z } from 'zod';

const GateTypeDef = [
    'Property/Main',
    'Metal',
    'Sliding',
    'Stroke',
    'Tubular',
    'Pipe',
    'Panel',
    'Livestock',
    'Field',
    'Hotwire',
    'Mesh',
] as const;

export const allGateTypes = [...GateTypeDef];

export type GateType = (typeof GateTypeDef)[number];

export const gateTypeSchema = z.enum(GateTypeDef);
